import React from 'react';

import { AuctionContextProvider } from '../../context/AuctionContext';
import { IOfferCardFragmentProps } from '../../types/offer-card';
import { OfferCardContainer } from './OfferCardContainer';
import { OfferContext } from '../../context';
import { combineComputedProps } from '../../utils/computedProps/combineComputedProps';
import { useApplicationContext } from '../../../../../shared/serp/containers/ApplicationContext';

export function OfferContainer(props: IOfferCardFragmentProps) {
  const ctx = useApplicationContext();

  const computedProps = React.useMemo(() => combineComputedProps(props, ctx), [props, ctx]);

  return (
    <OfferContext.Provider
      value={{
        // пропсы переданные фрагменту
        ...props,
        // вычисляемые свойства на основе переданных пропсов
        ...computedProps,
      }}
    >
      <AuctionContextProvider {...props}>
        <OfferCardContainer />
      </AuctionContextProvider>
    </OfferContext.Provider>
  );
}
